var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ucenter"},[_c('layout',{scopedSlots:_vm._u([{key:"sidebar",fn:function(){return [_c('side-menu')]},proxy:true}])},[_c('r-content')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }